import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useCommonVars } from "@wkComposables/useCommonVars";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { getPlace } from "@services/placesAPI";
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "TrendBanner",
  components: {
    BaseButton,
    BaseAutocomplete
  },
  props: {
    customContainerClasses: {
      type: String,
      default: ""
    },
    customContainerStyles: {
      type: String,
      default: ""
    }
  },
  setup() {
    var {
      cdn,
      wkLabels
    } = useCommonVars();
    return {
      cdn,
      wkLabels
    };
  },
  data() {
    return {
      place: undefined,
      loading: false
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 575;
    }
  },
  methods: {
    callbackFn(v) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!v) return;
        var res = yield getPlace(v);
        return res.map((place, index) => Object.assign(Object.assign({}, place), {
          id: index,
          label: place.displayName
        }));
      });
    },
    searchTrend() {
      console.log("searching trend");
      this.loading = true;
      if (!this.place || !this.place.cityURL && !this.place.zoneURL) {
        this.loading = false;
        return;
      }
      var URL;
      if (!this.place.zoneURL && this.place.cityURL) URL = window._trendURL + this.place.cityURL;else URL = window._trendURL + this.place.cityURL + "/" + this.place.zoneURL;
      if (URL) window.location.href = URL;
    }
  }
});